import "../css/connections.css";
import "../css/button.css";
import commoncss from "../css/common.module.css"
import buttoncss from "../css/button.module.css"
import { useState } from "react";
import {Button} from "../elements/Button";
import Modal from "../elements/Modal";
import Dropdown from "./../elements/Dropdown";
import InputGroup from "./../elements/InputGroup";
import Hierarchy from "./../elements/Hierarchy";
import Breadcrumb from "./../components/Breadcrumb";


export default function PushEntries() {
  const [displayModal, setDisplayModal] = useState(false);
  const [filterModal, setFilterModal] = useState(false);

  const breadcrumbItems = [
    {
      label: "Connections",
      link: "/myfinv2/connections",
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: "Pull",
      link: "/myfinv2/connections",
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    { label: "View Links", link: "", className: "headerLable" },
  ];

  const hierarchyData = {
    title: "Biffco Enterprises Ltd",
    dateRange: "Feb 11, 2025 to Aug 15, 2025",
    time: "Apr 10, 2025 08:34 PM",
    user: "Adrienne Vossler",
    children: [
      {
        title: "Loan Registers",
        date: "Mar 10, 2025",
        items: [
          "Client Loan Ledger",
          "Interest Accrued Report",
          "Loan Disbursement Report",
          "NPA List",
        ],
      },
      {
        title: "Receivable Registers",
        date: "Mar 10, 2025",
        items: [
          "Accounts Receivable Register",
          "Aging Report",
          "Invoice Payment Status",
        ],
      },
      {
        title: "Sales",
        date: "Mar 10, 2025 to Jan 30, 2026",
        items: ["GST Collected Report", "Recurring Billing Clients"],
      },
      {
        title: "Purchase",
        date: "Mar 10, 2025 to Jan 30, 2026",
        items: [
          "Vendor Payment Register",
          "Infrastructure Expenses",
          "Staff Salary Ledger",
          "Reimbursement Claims",
        ],
      },
      {
        title: "Book Closure",
        date: "Mar 10, 2025",
        items: [
          "Trial Balance Finalization",
          "Year-End Tax Adjustments",
          "Audit Adjustments Log",
        ],
      },
      {
        title: "Standalone FS",
        date: "Mar 10, 2025",
        items: ["Profit & Loss Statement", "Cash Flow Statement"],
      },
    ],
  };

  const handleClose = () => {
    setDisplayModal(false);
  };

  return (
    <>
      <div className="connections-wrapper">
        <Breadcrumb
          items={breadcrumbItems}
          headerActions={
            <Button
              btnColor={buttoncss.primary}
              label="Sync from ERP"
              onClick={() => {
              }}
            />
          }
        />

        
        <div className="connections-content info-content">
          <main>
            <Hierarchy data={hierarchyData} />
          </main>
        </div>
      </div>
      {filterModal && displayModal && (
        <Modal
          title="Filters"
          headerActions={
            <lable className="primaryLable clickable">Reset Filters</lable>
          }
          footerActions={
            <>
              <Button
                btnColor={buttoncss.secondary}
                onClick={() => {
                  handleClose();
                  setFilterModal(false);
                }}
                label="Cancel"
              />
              <span>
                <Button btnColor={buttoncss.secondary} label="Custom Filter" />
                &ensp;
                <Button btnColor={buttoncss.primary} label="Apply Filter" />
              </span>
            </>
          }
          onClose={() => console.log("Modal Closed")}
        >
          <InputGroup
            inputs={[
              <>
                <Dropdown
                  label="Ledger Code"
                  options={["TB001", "GL002"]}
                  onSelect={(value) => console.log("Selected:", value)}
                  placeHolder={"Select Ledger Code"}
                />
              </>,
              <>
                <Dropdown
                  label="Ledger Name"
                  options={["Trial Balance", "General Ledger"]}
                  onSelect={(value) => console.log("Selected:", value)}
                  placeHolder={"Select Ledger Name"}
                />
              </>,
            ]}
          />

          <Dropdown
            label="Preparer"
            options={["Adrienne Vossler", "Swizz Shannon"]}
            onSelect={(value) => console.log("Selected:", value)}
            placeHolder={"Select Preparer"}
          />

          <Dropdown
            label="Approver"
            options={["Adrienne Vossler", "Swizz Shannon"]}
            onSelect={(value) => console.log("Selected:", value)}
            placeHolder={"Select Approver"}
          />
        </Modal>
      )}
    </>
  );
}
